module.exports = __webpack_public_path__ + "static/media/Apple.c11fdbe0.svg";